import { ListenerHolder } from '@shm-open/utilities';
const listenerHolder = new ListenerHolder();
export function dispatchEvent(type, data) {
    listenerHolder.dispatch(type, data);
}
export function addListener(type, listener) {
    return listenerHolder.addListener(type, listener);
}
